import Vue from 'vue';
import VueRouter from 'vue-router';
import Installation from '@/views/getting-started/Installation';
import Structure from '@/views/getting-started/Structure';
import Configuration from '@/views/customisation/Configuration';
import BgAttachment from '@/views/utilities/background/BgAttachment';
import BgColor from '@/views/utilities/background/BgColor';
import BgPosition from '@/views/utilities/background/BgPosition';
import BgRepeat from '@/views/utilities/background/BgRepeat';
import BgSize from '@/views/utilities/background/BgSize';
import BrdColor from '@/views/utilities/border/BrdColor';
import BrdRadius from '@/views/utilities/border/BrdRadius';
import BrdStyle from '@/views/utilities/border/BrdStyle';
import BrdWidth from '@/views/utilities/border/BrdWidth';
import JustifyContent from '@/views/utilities/alignment/JustifyContent';
import JustifyItems from '@/views/utilities/alignment/JustifyItems';
import JustifySelf from '@/views/utilities/alignment/JustifySelf';
import Direction from '@/views/utilities/flex/Direction';
import Grow from '@/views/utilities/flex/Grow';
import Order from '@/views/utilities/flex/Order';
import Shrink from '@/views/utilities/flex/Shrink';
import Wrap from '@/views/utilities/flex/Wrap';
import Columns from '@/views/utilities/grid/Column';
import Flow from '@/views/utilities/grid/Flow';
import Gap from '@/views/utilities/grid/Gap';
import Rows from '@/views/utilities/grid/Row';
import TemplateColumns from '@/views/utilities/grid/TemplateColumns';
import TemplateRows from '@/views/utilities/grid/TemplateRows';
import Cursor from '@/views/utilities/interactions/Cursor';
import PointerEvents from '@/views/utilities/interactions/PointerEvents';
import Resize from '@/views/utilities/interactions/Resize';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/getting-started/installation',
    name: 'Installation',
    component: Installation,
  },
  {
    path: '/getting-started/installation',
    name: 'Installation',
    component: Installation,
  },
  {
    path: '/getting-started/structure',
    name: 'Structure',
    component: Structure,
  },
  {
    path: '/customisation/configuration',
    name: 'Configuration',
    component: Configuration,
  },
  {
    path: '/utilities/background/attachment',
    name: 'BgAttachment',
    component: BgAttachment,
  },
  {
    path: '/utilities/background/color',
    name: 'BgColor',
    component: BgColor,
  },
  {
    path: '/utilities/background/position',
    name: 'BgPosition',
    component: BgPosition,
  },
  {
    path: '/utilities/background/repeat',
    name: 'BgRepeat',
    component: BgRepeat,
  },
  {
    path: '/utilities/background/size',
    name: 'BgSize',
    component: BgSize,
  },
  {
    path: '/utilities/border/color',
    name: 'BrdColor',
    component: BrdColor,
  },
  {
    path: '/utilities/border/radius',
    name: 'BrdRadius',
    component: BrdRadius,
  },
  {
    path: '/utilities/border/style',
    name: 'BrdStyle',
    component: BrdStyle,
  },
  {
    path: '/utilities/border/width',
    name: 'BrdWidth',
    component: BrdWidth,
  },
  {
    path: '/utilities/alignment/justify-content',
    name: 'JustifyContent',
    component: JustifyContent,
  },
  {
    path: '/utilities/alignment/justify-items',
    name: 'JustifyItems',
    component: JustifyItems,
  },
  {
    path: '/utilities/alignment/justify-self',
    name: 'JustifySelf',
    component: JustifySelf,
  },
  {
    path: '/utilities/flex/direction',
    name: 'Direction',
    component: Direction,
  },
  {
    path: '/utilities/flex/grow',
    name: 'Grow',
    component: Grow,
  },
  {
    path: '/utilities/flex/order',
    name: 'Order',
    component: Order,
  },
  {
    path: '/utilities/flex/shrink',
    name: 'Shrink',
    component: Shrink,
  },
  {
    path: '/utilities/flex/wrap',
    name: 'Wrap',
    component: Wrap,
  },
  {
    path: '/utilities/grid/columns',
    name: 'Columns',
    component: Columns,
  },
  {
    path: '/utilities/grid/flow',
    name: 'Flow',
    component: Flow,
  },
  {
    path: '/utilities/grid/gap',
    name: 'Gap',
    component: Gap,
  },
  {
    path: '/utilities/grid/rows',
    name: 'Rows',
    component: Rows,
  },
  {
    path: '/utilities/grid/template-columns',
    name: 'TemplateColumns',
    component: TemplateColumns,
  },
  {
    path: '/utilities/grid/template-rows',
    name: 'TemplateRows',
    component: TemplateRows,
  },
  {
    path: '/utilities/interactions/cursor',
    name: 'Cursor',
    component: Cursor,
  },
  {
    path: '/utilities/interactions/pointer-events',
    name: 'PointerEvents',
    component: PointerEvents,
  },
  {
    path: '/utilities/interactions/resize',
    name: 'Resize',
    component: Resize,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'site-menu__link--active',
});

export default router;
